export default "__VITE_ASSET__9a18bd97__"